var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"analyticsSubmissions"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',[_c('b',[_vm._v("Number of Subscribers:")]),_vm._v(" "+_vm._s(_vm.submissions.length)+" ")]),_c('hr')])])])
}
var staticRenderFns = []

export { render, staticRenderFns }